export function logger(error: any) {
  console.log(error);
}
